<template>
    <div class="page">
        <div class="container-div">
            <ion-grid>
                <ion-row>
                    <ion-col size="12" size-sm="12" size-md="4" size-lg="4">
                        <div class="l-c1">
                            <div class="card-header">
                                <div class="kpi-icon-canva blue">
                                    <ion-icon :icon="people"></ion-icon>
                                </div>
                                <ion-label class="display-value kpi-content">Customer Visits <span v-if="customerVisitCountData && customerVisitCountData.displayChart">{{": " + customerVisitCountData.count }}</span></ion-label>
                                <ion-icon :icon="refresh" class="refresh-icon" @click="LoadCustomerVisitCount()"></ion-icon>
                                
                            </div>
                            <div v-if="displayLineChart1" >
                                <!-- <p class="display-value" v-if="customerVisitCountData.displayChart == true">{{"Customer Visits : " + customerVisitCountData.count }}</p> -->
                                <!-- <div class="card-header">
                                    <div class="kpi-icon-canva blue">
                                        <ion-icon :icon="people"></ion-icon>
                                    </div>
                                    <div class="kpi-content">
                                        <p class="display-value" v-if="customerVisitCountData && customerVisitCountData.displayChart">{{"Customer Visits : " + customerVisitCountData.count }}</p>
                                    </div>
                                    <ion-icon
                                        :icon="refresh"
                                        class="refresh-icon"
                                        @click="LoadCustomerVisitCount()">
                                    </ion-icon>
                                </div> -->
                                <span class="noStations" v-if="customerVisitCountData.displayChart == false">No data to display</span>
                                <canvas id="lineChart1"></canvas>
                                <!-- <p class="noStations"  style="text-align: center;" v-if="customerVisitCountData.displayChart == false">Customer Visits: No data to display</p> -->
                            </div>
                        </div>
                        
                    </ion-col>
                    <ion-col size="12" size-sm="12" size-md="4" size-lg="4">
                        <div class="l-c2">
                            <div class="card-header">
                                <div class="kpi-icon-canva purple">
                                    <ion-icon :icon="pieChart"></ion-icon>
                                </div>
                                <ion-label class="display-value kpi-content">Transaction Counts <span v-if="transactionCountData && transactionCountData.displayChart">{{": " + transactionCountData.count }}</span></ion-label>
                                <ion-icon :icon="refresh" class="refresh-icon" @click="loadTransactionCount()"></ion-icon>
                            </div>
                            <div v-if="displayLineChart2">
                                <!-- <div class="card-header">
                                    <div class="kpi-icon-canva purple">
                                        <ion-icon :icon="pieChart"></ion-icon>
                                    </div>
                                    <div class="kpi-content">
                                        <p class="display-value" v-if="customerVisitCountData && customerVisitCountData.displayChart">{{"Transaction Counts : " + transactionCountData.count }}</p>
                                    </div>
                                    <ion-icon
                                        :icon="refresh"
                                        class="refresh-icon"
                                        @click="loadTransactionCount()">
                                    </ion-icon>
                                </div> -->
                                <span class="noStations"  v-if="transactionCountData.displayChart == false">No data to display</span>
                                <canvas id="lineChart2"></canvas>
                            <!-- <p class="noStations"  style="text-align: center;" v-if="transactionCountData.displayChart == false">Transaction Counts: No data to display</p> -->
                            </div>
                        </div>
                    </ion-col>
                    <ion-col size="12" size-sm="12" size-md="4" size-lg="4">
                        <div class="l-c3">
                            <div class="card-header">
                                <div class="kpi-icon-canva green">
                                    ₹
                                </div>
                                <ion-label class="display-value kpi-content">Revenue (INR) <span v-if="revenueCountData && revenueCountData.displayChart">{{": " + revenueCountData.count }}</span></ion-label>
                                <ion-icon :icon="refresh" class="refresh-icon" @click="loadRevenueCount()"></ion-icon>
                            </div>
                            <div v-if="displayLineChart3">
                                <!-- <div class="card-header">
                                    <div class="kpi-icon-canva green">
                                        ₹
                                    </div>
                                    <div class="kpi-content">
                                        <p class="display-value" v-if="customerVisitCountData && customerVisitCountData.displayChart">{{"Revenue (INR) : " + revenueCountData.count }}</p>
                                    </div>
                                    <ion-icon
                                        :icon="refresh"
                                        class="refresh-icon"
                                        @click="loadRevenueCount()">
                                    </ion-icon>
                                </div> -->
                                <span class="noStations" v-if="revenueCountData.displayChart == false">No data to display</span>
                                <canvas id="lineChart3"></canvas>
                            <!-- <p class="noStations"  style="text-align: center;" v-if="revenueCountData.displayChart == false">Revenue (INR): No data to display</p> -->
                            </div>
                        </div>
                    </ion-col>
                </ion-row>
                <!-- <ion-row>
                    <ion-col size="3.5" class="l-c1" size-lg="3.5" size-xl="3.5" size-md="3.5" size-sm="12" size-xs="12">
                        <ion-label v-if="!displayLineChart1" style="font-weight: bold;">Customer Visits</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart1" @click="LoadCustomerVisitCount()">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart1">
                            <p class="display-value" v-if="customerVisitCountData.displayChart == true">{{"Customer Visits : " + customerVisitCountData.count }}</p>
                            <canvas id="lineChart1"></canvas>
                            <p class="noStations"  style="text-align: center;" v-if="customerVisitCountData.displayChart == false">Customer Visits: No data to display</p>
                        </div>
                    </ion-col>
                    <ion-col size="0.3" size-sm="0.3" size-lg="0.3"  size-md="0.3" size-xs="0.3"></ion-col>
                    <ion-col size="3.5" size-sm="12" size-lg="3.5"  size-md="3.5" class="l-c2" size-xs="12">
                        <ion-label v-if="!displayLineChart2" style="font-weight: bold;">Transaction Counts</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart2" @click="loadTransactionCount()">
                        <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart2">
                        <p class="display-value" v-if="transactionCountData.displayChart == true">{{"Transaction Counts : " + transactionCountData.count }}</p>
                        <canvas id="lineChart2"></canvas>
                        <p class="noStations"  style="text-align: center;" v-if="transactionCountData.displayChart == false">Transaction Counts: No data to display</p>
                        </div>
                    </ion-col>
                    <ion-col size="0.3" size-md="0.3" size-lg="0.3"  size-sm="0.3" size-xs="0.3"></ion-col>
                    <ion-col size="3.5" size-md="3.5" size-lg="3.5"  size-sm="12" class="l-c3" size-xs="12">
                        <ion-label v-if="!displayLineChart3" style="font-weight: bold;">Revenue (INR)</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart3" @click="loadRevenueCount()">
                        <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart3">
                        <p class="display-value" v-if="revenueCountData.displayChart == true">{{"Revenue (INR) : " + revenueCountData.count }}</p>
                        <canvas id="lineChart3"></canvas>
                        <p class="noStations"  style="text-align: center;" v-if="revenueCountData.displayChart == false">Revenue (INR): No data to display</p>
                        </div>
                    </ion-col>
                </ion-row> -->
                <ion-row class="chart-label rectangle-dump" v-if="displayFenfeoAdminChart">
                    <ion-col size="1.5"></ion-col>
                    <ion-col size="12" size-sm="12" size-md="4" size-lg="4.5">
                        <div class="kpi-card-total-consumed">
                            <div class="kpi-icon orange">
                                <ion-icon :icon="pulse"></ion-icon>
                            </div>
                            <div class="kpi-content">
                                <div class="kpi-title">
                                    Total Energy Consumed(kWh) Till Date:
                                    <span class="gas-value">{{ greenHousGasData.totalEnegey }}</span>
                                </div>

                                <div class="kpi-title">
                                    Kg CO2e:
                                    <span class="gas-value">{{ greenHousGasData.totalCo2Index }}</span>
                                </div>
                            </div>
                        </div>
                    </ion-col>
                    <ion-col size="12" size-sm="12" size-md="4" size-lg="4.5">
                        <div class="kpi-card-total-consumed">
                            <div class="kpi-icon orange">
                                <ion-icon :icon="pulse"></ion-icon>
                            </div>
                            <div class="kpi-content">
                                <div class="kpi-title">
                                    Energy Consumed(kWh) for the Below period:
                                    <span class="gas-value">{{ greenHousGasData.consumedKWH }}</span>
                                </div>

                                <div class="kpi-title">
                                    Kg CO2e:
                                    <span class="gas-value">{{ greenHousGasData.co2index }}</span>
                                </div>
                            </div>
                        </div>
                    </ion-col>
                    <ion-col size="1.5"></ion-col>
                </ion-row>
                <ion-row class="rectangle-dump1">
                    <!-- <ion-col size="1" size-md="1" size-lg="1"  size-sm="2" size-xs="0.5"></ion-col> -->
                    <ion-col size="12" size-md="10" size-lg="10"  size-sm="10" size-xs="11">
                        <canvas id="barChart1" class="barChart1"></canvas>
                    </ion-col>
                    <!-- <ion-col size="1" size-md="1" size-lg="1"  size-sm="2" size-xs="0.5"></ion-col> -->
                </ion-row>
            </ion-grid>
        </div>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent, render } from "vue";
import { refresh } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { people, pieChart,batteryCharging, pulse, barChart } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'energyConsumedDashboard',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    props: {
        consumeEnergyData : {type: Object}
    },
    watch: {
    consumeEnergyData: {
        deep: true,
        immediate: true,

        handler(newData) {

            if (!newData) {
                return;
            }

            this.greenHousGasData = newData;

            this.$nextTick(() => {
                this.drawBarChart(newData);
            });
        }
    }
},
    data() {
        return {
            refresh,
            pulse,
            barChart,
            people,
            pieChart,
            batteryCharging,
            chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
            chartName: "",
            branchId: "",
            stationId: "",
            outputId: "",
            filterId: "",
            chartTypeInd: true,
            doughnutChartInd: true,
            myChart1: null,
            chargerStatusData: "",
            displayInd: false,
            loaderTab: true,
            noStationAssociatedInd: true,
            lineChart1: null,
            lineChart2: null,
            lineChart3: null,
            displayLineChart1: false,
            displayLineChart2: false,
            displayLineChart3: false,
            displayLineChart4: false,
            displayChargerStatus: false,
            displayFenfeoAdminChart: false,
            chargerCurrentStatusChart: null,
            dailyUsageBarChart: null,
            greenHousGasData: null,
            customerVisitCountData: null,
            transactionCountData: null,
            revenueCountData: null,
            getPayload: "",
            payload: "",
            
        }
    },
    async mounted() {
        this.getPayload = this.consumeEnergyData.branchDetails;
        this.payload = {
            branchId : this.getPayload.branchId,
            stationId : this.getPayload.stationId,
            outputId : this.getPayload.outputId,
            filterId : this.getPayload.filterId,
            fyYear : this.getPayload.fyYear,
            fyMonth : this.getPayload.fyMonth,
        }
      this.displayFenfeoAdminChart = true
      this.greenHousGasData = this.consumeEnergyData;
      let brId = (localStorage.getItem("branchId"));
      if(brId) {
        this.branchId = brId;
      }
    //   if(this.dailyUsageBarChart) {
    //     this.dailyUsageBarChart.destroy();
    //     this.dailyUsageBarChart = null;
    //   }
    //   this.greenHousGasChart(this.greenHousGasData)
        this.drawBarChart(this.greenHousGasData);
        this.loaderTab = false;
    },
    methods: {
        async greenHousGasChart(greenHousGasData) {
            try {
                this.loaderTab = true;
                var ctx = document.getElementById('barChart1');
                if (this.dailyUsageBarChart) {
                    this.dailyUsageBarChart.destroy();
                    this.dailyUsageBarChart = null;
                }
                if(greenHousGasData.displayChart == false) {
                    ctx = null;
                } else {
                    var data = {
                        labels: greenHousGasData.label,
                        datasets: [{
                            label: 'Energy Consumed(kWh) :'+ greenHousGasData.consumedKWH + "     "+ "Kg CO2e :" + greenHousGasData.co2index,
                            // fillColor: "#79D1CF",
                            // strokeColor: "#79D1CF",
                            fontSize: 30,
                            data: greenHousGasData.data,
                            fill: true,
                            backgroundColor: 'green',
                            barThickness: 40,
                            maxBarThickness: 40,
                            categoryPercentage: 0.8,
                            barPercentage: 0.8,
                            minBarLength: 0.5
                        }]
                    }
                    this.dailyUsageBarChart = new Chart(ctx, {
                        type: 'bar',
                        data: data,
                        options : {
                            legend: {
                                display: false
                            },
                            "animation": {
                                "hover": {
                                    "animationDuration": 2
                                },
                                "duration": 1,
                                "onComplete": function() {
                                    var chartInstance = this.chart,
                                    ctx = chartInstance.ctx;
                                    ctx.font = Chart.helpers.fontString("17", Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'bottom';
                                    this.data.datasets.forEach(function(dataset, i) {
                                        var meta = chartInstance.controller.getDatasetMeta(i);
                                        meta.data.forEach(function(bar, index) {
                                            var data = dataset.data[index];
                                            ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                        });
                                    });
                                }
                            },
                            tooltips: {
                                enabled: false
                            },
                            elements: {
                                point:{
                                    radius: 0
                                }
                            },
                            scales: {
                                xAxes: [{
                                    position:'top',
                                    // barPercentage: 10,
                                    // barThickness: 10,
                                    // maxBarThickness: 10,
                                    gridLines: {
                                        display:true
                                    },
                                    ticks: {
                                        display: true,
                                        fontSize:17,
                                        fontColor: "red"
                                    }
                                }],
                                yAxes: [
                                    {
                                        display: false,
                                        gridLines: {
                                            display: true
                                        },
                                        ticks: {
                                            max: Math.max(...data.datasets[0].data) + 10,
                                            display: false,
                                            beginAtZero: true
                                        }
                                    }
                                ],
                            }
                        }
                    });
                }
                this.loaderTab = false;
            }  catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        
        // async LoadCustomerVisitCount() {
        //     try {
        //         this.loaderTab = true;
        //         this.customerVisitCountData = await new CorporateService().getCustomerVisitCountChartData(this.payload);
        //         if(this.customerVisitCountData) {
        //             this.displayLineChart1 = true;
        //             setTimeout(() => {
        //                 this.customerVisitCountChart(this.customerVisitCountData);
        //             }, 500)
        //         }
        //         this.loaderTab = false;
        //     } catch(error) {
        //         this.loaderTab = false;
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //     }
           
        
        // },

        async LoadCustomerVisitCount() {
            try {
                this.loaderTab = true;

                this.customerVisitCountData =
                    await new CorporateService().getCustomerVisitCountChartData(this.payload);

                if (this.customerVisitCountData) {
                    this.displayLineChart1 = true;

                    await this.$nextTick();

                    this.customerVisitCountChart(this.customerVisitCountData);
                }

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            } finally {
                this.loaderTab = false;
            }
        },


        // async loadTransactionCount() { 
        //     try {
        //         this.loaderTab = true;
        //         this.transactionCountData = await new CorporateService().getTransactionCountChartData(this.payload);
        //         if(this.transactionCountData) {
        //             this.displayLineChart2 = true;
        //             setTimeout(() => {
        //                 this.transactionCountChart(this.transactionCountData);
        //             }, 500)
        //         }
        //         this.loaderTab = false;
        //     } catch(error) {
        //         this.loaderTab = false;
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //     }   
            
        // },
        async loadTransactionCount() {
            try {
                this.loaderTab = true;

                this.transactionCountData =
                    await new CorporateService().getTransactionCountChartData(this.payload);

                if (this.transactionCountData) {
                    this.displayLineChart2 = true;

                    await this.$nextTick();

                    this.transactionCountChart(this.transactionCountData);
                }

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            } finally {
                this.loaderTab = false;
            }
        },

        // async loadRevenueCount() {  
        //     try {
        //         this.loaderTab = true;
        //         this.revenueCountData = await new CorporateService().getRevenueCountChartData(this.payload);
        //         if(this.revenueCountData) {
        //             this.displayLineChart3 = true;
        //             setTimeout(() => {
        //             this.revenueCountChart(this.revenueCountData);
        //             }, 500)
        //         }
        //         this.loaderTab = false;
        //     } catch(error) {
        //         this.loaderTab = false;
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //     }                                           
            
        // },

        async loadRevenueCount() {
            try {
                this.loaderTab = true;

                this.revenueCountData =
                    await new CorporateService().getRevenueCountChartData(this.payload);

                if (this.revenueCountData) {
                    this.displayLineChart3 = true;

                    await this.$nextTick();

                    this.revenueCountChart(this.revenueCountData);
                }

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            } finally {
                this.loaderTab = false;
            }
        },


        // async revenueCountChart(revenueData) {
        //     try {
        //         this.loaderTab = true;
        //         var ctx = document.getElementById('lineChart3');
        //         if(revenueData.displayChart == false) {
        //         ctx = null;
        //         } else {
        //         var myChart = new Chart(ctx, {
        //         type: 'line',
        //         data: {
        //             labels: revenueData.label,
        //             datasets: [{
        //             label: 'Revenue (INR) ' +"\n"+ revenueData.count,
        //             data: revenueData.data,
        //             fill: true,
        //             borderColor: 'rgb(10, 192, 10)',
        //             tension: 0.3,
        //             backgroundColor: 'rgba(10, 85, 10, 0.4)',
        //             }]
        //         },
        //         options : {
        //             plugins: {
        //                 legend: {
        //                     display: false
        //                 },
        //                 tooltip: {
        //                     enabled: false
        //                 }
        //             },
        //             animations: {
        //                 tension: {
        //                     duration: 1000,
        //                     easing: 'linear',
        //                     from: 1,
        //                     to: 0,
        //                     loop: true
        //                 }
        //             },
        //             // legend: {
        //             // display: false
        //             // },
        //             // tooltips: {
        //             // enabled: false
        //             // },
        //             elements: {
        //             point:{
        //                 radius: 0
        //             }
        //             },
        //             scales: {
        //                 xAxes: [{
        //                     gridLines: {
        //                         display:false
        //                     },
        //                     ticks: {
        //                     display: false
        //                     }
        //                 }],
        //                 yAxes: [{
        //                     gridLines: {
        //                         display:false
        //                     },
        //                     ticks: {
        //                     display: false
        //                     }  
        //                 }]
        //             }
        //         }
        //         });
        //     }
        //     this.loaderTab = false;
        // } catch(error) {
        //     this.loaderTab = false;
        //     let serviceError = migratedTryParseServiceError(error);
        //     new ToastUtils().presentToast(serviceError.description);
        // } 
        
        // },
        // async customerVisitCountChart(chartData) {
        //     try {
        //         this.loaderTab = true;
        //         var ctx = document.getElementById('lineChart1');
        //         if(chartData.displayChart == false) {
        //             ctx = null;
        //         } else {
        //             var myChart = new Chart(ctx, {
        //             type: 'line',
        //             data: {
        //                 labels: chartData.label,
        //                 datasets: [{
        //                     label: 'Customer Visits' +"\n"+ chartData.count,
        //                     data: chartData.data,
        //                     fill: true,
        //                     borderColor: 'rgb(150, 120, 150)',
        //                     tension: 0.1,
        //                     backgroundColor: 'rgba(251, 85, 85, 0.4)',
        //                 }]
        //             },
        //             options : {
        //                 plugins: {
        //                     legend: {
        //                         display: false
        //                     },
        //                     tooltip: {
        //                         enabled: false
        //                     }
        //                 },
        //                 // responsive: true,
        //                 animations: {
        //                     tension: {
        //                         duration: 1000,
        //                         easing: 'linear',
        //                         from: 1,
        //                         to: 0,
        //                         loop: true
        //                     }
        //                 },
        //                 maintainAspectRatio: true,
        //                 // legend: {
        //                 //     display: false
        //                 // },
        //                 // tooltips: {
        //                 //     enabled: false
        //                 // },
        //                 elements: {
        //                     point:{
        //                         radius: 0
        //                     }
        //                 },
        //                 scales: {
        //                     // xAxes: [{
        //                     //     gridLines: {
        //                     //         display:false
        //                     //     },
        //                     //     ticks: {
        //                     //     display: false
        //                     //     }
        //                     // }],
        //                     // x: {
        //                     //     display: false
        //                     // },
        //                     // y: {
        //                     //     display: false,
        //                     //     grid: {
        //                     //         display: true

        //                     //     }
        //                     // },
        //                     // yAxes: [{
        //                     //     gridLines: {
        //                     //         display:false
        //                     //     },
        //                     //     ticks: {
        //                     //     display: false
        //                     //     }  
        //                     // }]
        //                 }
        //             }
        //             });
        //         }
        //         this.loaderTab = false;
        //     } catch(error) {
        //         this.loaderTab = false;
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //     } 
        // },
        

        async revenueCountChart(revenueData) {
            try {
                const ctx = document.getElementById('lineChart3');

                // Destroy previous chart
                if (this.lineChart3) {
                    this.lineChart3.destroy();
                    this.lineChart3 = null;
                }

                if (!revenueData ||
                    revenueData.displayChart === false ||
                    !ctx) {
                    return;
                }

                this.lineChart3 = new Chart(ctx, {
                    type: 'line',

                    data: {
                        labels: revenueData.label,

                        datasets: [{
                            label: 'Revenue (INR) ' + "\n" + revenueData.count,
                            data: revenueData.data,
                            fill: true,
                            borderColor: 'rgb(10, 192, 10)',
                            tension: 0.3,
                            backgroundColor: 'rgba(10, 85, 10, 0.4)'
                        }]
                    },

                    options: {
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        },

                        animation: {
                            duration: 500
                        },

                        maintainAspectRatio: true,

                        elements: {
                            point: {
                                radius: 0
                            }
                        }
                    }
                });

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        async customerVisitCountChart(chartData) {
            try {
                const ctx = document.getElementById('lineChart1');

                // Remove old chart
                if (this.lineChart1) {
                    this.lineChart1.destroy();
                    this.lineChart1 = null;
                }

                if (!chartData || chartData.displayChart === false || !ctx) {
                    return;
                }

                // Create new chart
                this.lineChart1 = new Chart(ctx, {
                    type: 'line',

                    data: {
                        labels: chartData.label,

                        datasets: [{
                            label: 'Customer Visits' + "\n" + chartData.count,
                            data: chartData.data,
                            fill: true,
                            borderColor: 'rgb(150, 120, 150)',
                            tension: 0.1,
                            backgroundColor: 'rgba(251, 85, 85, 0.4)'
                        }]
                    },

                    options: {
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        },

                        animation: {
                            duration: 500
                        },

                        maintainAspectRatio: true,

                        elements: {
                            point: {
                                radius: 0
                            }
                        }
                    }
                });

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        
        // async transactionCountChart(transactionData) {
        //     try {
        //         this.loaderTab = true;
        //         var ctx = document.getElementById('lineChart2');
        //         if(transactionData.displayChart == false) {
        //             ctx = null;
        //         } else {
        //             var myChart = new Chart(ctx, {
        //             type: 'line',
        //             data: {
        //                 labels: transactionData.label,
        //                 datasets: [
        //                     {
        //                         label: 'Transaction Counts' +"\n"+ transactionData.count,
        //                         data: transactionData.data,
        //                         fill: true,
        //                         borderColor: 'rgb(192, 40, 192)',
        //                         tension: 0.3,
        //                         backgroundColor: 'rgba(10, 85, 100, 0.4)',
        //                     }
        //                 ]
        //             },
        //             options : {
        //                 plugins: {
        //                     legend: {
        //                         display: false
        //                     },
        //                     tooltip: {
        //                         enabled: false
        //                     }
        //                 },
        //                 animations: {
        //                     tension: {
        //                         duration: 1000,
        //                         easing: 'linear',
        //                         from: 1,
        //                         to: 0,
        //                         loop: true
        //                     }
        //                 },
        //                 // legend: {
        //                 // display: false
        //                 // },
        //                 // tooltips: {
        //                 // enabled: false
        //                 // },
        //                 elements: {
        //                     point:{
        //                         radius: 0
        //                     }
        //                 },
        //                 scales: {
        //                         xAxes: [
        //                             {
        //                                 gridLines: {
        //                                     display:false
        //                                 },
        //                                 ticks: {
        //                                     display: false
        //                                 }
        //                             }
        //                         ],
        //                         yAxes: [
        //                             {
        //                                 gridLines: {
        //                                     display:false
        //                                 },
        //                                 ticks: {
        //                                     display: false
        //                                 }  
        //                             }
        //                         ]
        //                     }
        //                 }
        //             });
        //         }
        //         this.loaderTab = false;
        //     } catch(error) {
        //         this.loaderTab = false;
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //     } 
        // },
        async transactionCountChart(transactionData) {
            try {
                const ctx = document.getElementById('lineChart2');

                // Destroy previous chart
                if (this.lineChart2) {
                    this.lineChart2.destroy();
                    this.lineChart2 = null;
                }

                if (!transactionData ||
                    transactionData.displayChart === false ||
                    !ctx) {
                    return;
                }

                this.lineChart2 = new Chart(ctx, {
                    type: 'line',

                    data: {
                        labels: transactionData.label,

                        datasets: [{
                            label: 'Transaction Counts' + "\n" + transactionData.count,
                            data: transactionData.data,
                            fill: true,
                            borderColor: 'rgb(192, 40, 192)',
                            tension: 0.3,
                            backgroundColor: 'rgba(10, 85, 100, 0.4)'
                        }]
                    },

                    options: {
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        },

                        animation: {
                            duration: 500
                        },

                        maintainAspectRatio: true,

                        elements: {
                            point: {
                                radius: 0
                            }
                        }
                    }
                });

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        
        drawBarChart(greenHousGasData) {
            try {
                const maxValue = Math.max(...greenHousGasData.data)
                const yAxisMaxValue = maxValue +(maxValue/100*20)
                this.loaderTab = true;
                var ctx = document.getElementById('barChart1');
                  if (this.dailyUsageBarChart) {
                    this.dailyUsageBarChart.destroy();
                    this.dailyUsageBarChart = null;
                }
                const labels = greenHousGasData.label;
                const data = {
                    labels: labels,
                    datasets: [{
                        label: 'Energy Consumed(kWh) :'+ greenHousGasData.consumedKWH + "     "+ "Kg CO2e :" + greenHousGasData.co2index,
                        data: greenHousGasData.data,
                        borderWidth: 1,
                        backgroundColor: 'rgba(46, 204, 113)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        barThickness: 20,
                        maxBarThickness: 20,
                        categoryPercentage: 0.8,
                        barPercentage: 0.8,
                        minBarLength: 0.5
                    }]
                };
                this.dailyUsageBarChart = new Chart(ctx, {
                    type: 'bar',
                    data: data,
                    options: {
                        animation: {
                            duration: 1,
                            onComplete: function() {
                                
                                var chartInstance = this;
                                var ctx = chartInstance.ctx;  
                                
                                chartInstance.data.datasets.forEach(function(dataset, i) {
                                    var meta = chartInstance.getDatasetMeta(i);  
                                    meta.data.forEach(function(bar, index) {
                                        var data = dataset.data[index];  
                                        // ctx.fillStyle = '#000';  
                                        // ctx.font = 'bold 12px solid';  
                                        // ctx.textAlign = 'center';  
                                        // ctx.textBaseline = 'bottom'; 
                                        // ctx.fillText(data != 0 ? data : "", bar.x, bar.y - 5);  

                                        if (data != 0) {
                                            var x = bar.x;
                                            var y = bar.y;

                                            ctx.save(); 
                                            ctx.translate(x, y - 24); 
                                            ctx.rotate(-Math.PI / 2); 
                                            ctx.fillStyle = '#000';
                                            ctx.font = 'bold 12px sans-serif';
                                            ctx.textAlign = 'center';
                                            ctx.textBaseline = 'middle';
                                            ctx.fillText(data, 0, 0); 

                                            ctx.restore(); 
                                        }
                                    });
                                });
                            }
                        },
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        },
                        scales: {
                            y: {
                                max: yAxisMaxValue,
                                grid: {
                                    display: true
                                },
                                ticks: {
                                    display: true,
                                    font: {
                                        size: 12
                                    },
                                color: Chart.defaults.color = "rgba(242, 38, 19)"
                                },
                                border: {
                                    display: true,
                                    color: Chart.defaults.color = "#2dd55b"
                                }    
                            },
                            x: {
                                grid: {
                                    display: true
                                },
                                ticks: {
                                    display: true,
                                    font: {
                                        size: 12
                                    },
                                    color: Chart.defaults.color = "rgba(242, 38, 19)"
                                },
                                border: {
                                    display: true,
                                    color: Chart.defaults.color = "#2dd55b"
                                }
                            }
                        }                
                    },
                })
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    },
})
</script>

<style scoped>

.container-div {
  margin: 2px 25px 0px 26px;
}

/* ================= KPI CARDS ================= */

.l-c1,
.l-c2,
.l-c3,
.l-c4 {
  width: 100%;
  border-radius: 10px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 6px 25px rgba(0,0,0,.08);
  height: 100%;
}

.kpi-card {
  background:#fff;
  border-radius:10px;
  padding:20px;
  display:flex;
  align-items:flex-start;
  box-shadow:0 6px 25px rgba(0,0,0,.08);
  min-height:90px;
}

.kpi-card-total-consumed {
  background:#fff;
  border-radius:10px;
  padding:10px;
  display:flex;
  align-items:center;
  box-shadow:0 4px 20px rgba(0,0,0,.08);
}

.kpi-icon {
  width:32px;
  height:32px;
  border-radius:50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:white;
  font-size:20px;
  flex-shrink:0;
}

.kpi-icon-canva {
  width:28px;
  height:28px;
  border-radius:50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#fff;
  flex-shrink:0;
}

.blue {
  background:rgba(226,19,19,.4);
}

.purple {
  background:linear-gradient(135deg,#bb55ff,#7c3aed);
}

.green {
  background:linear-gradient(135deg,#32d583,#16a34a);
}

.orange {
  background:linear-gradient(135deg,#ffbf3f,#f59e0b);
}

.kpi-content {
  margin-left:14px;
  flex:1;
}

.kpi-title {
  font-size:14px;
}

.gas-value {
  font-weight:bold;
  color:#1a1a1a;
}

/* ================= CHART CARDS ================= */

canvas {
  max-width:115%;
}

#lineChart1,
#lineChart2,
#lineChart3 {
  width:99% !important;
  height:160px !important;
}

.barChart1 {
  width:180% !important;
  height:400px !important;
  margin:10px;
  padding: 0px 20px 0px 20px;
  /* display:block; */
}

.rectangle-dump,
.rectangle-dump1 {
  margin-top:4px;
  background:#fff;
  border-radius:10px;
  box-shadow:0 6px 25px rgba(0,0,0,.08);
  padding:2px;
}

/* ================= HEADER ================= */

.card-header {
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:6px;
}

.display-value {
  font-weight:bold;
  /* margin:0; */
}

.refresh-icon {
  font-size:22px;
  cursor:pointer;
}

/* ================= STATUS ================= */

.status-info {
  padding:15px;
  border:2px solid #ddd;
  border-radius:10px;
}

/* ================= EMPTY DATA ================= */

.noStations {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* ================= BUTTON ================= */

.btn-refresh {
  height:40px;
  font-size:1.2rem;
  --background:#e1899c;
}


/* ================= TABLET ================= */

@media(max-width:991px){

  .container-div {
    margin:10px;
  }

  .kpi-title {
    font-size:13px;
  }


  #lineChart1,
  #lineChart2,
  #lineChart3 {
    height:220px !important;
  }


  .barChart1 {
    width: 100% !important;
    min-width: 600px;
    padding: 0px !important;
    height: 320px !important;
  }

}



/* ================= MOBILE ================= */

@media(max-width:576px){

  .container-div {
    margin:5px;
  }


  .l-c1,
  .l-c2,
  .l-c3 {
    margin-bottom:15px;
  }


  .kpi-card {
    padding:12px;
  }


  .kpi-icon {
    width:28px;
    height:28px;
  }

  .kpi-title {
    font-size:12px;
  }


  #lineChart1,
  #lineChart2,
  #lineChart3 {
    height:200px !important;
  }


  .barChart1 {
    width: 100% !important;
    min-width: 300px;
    padding: 0px !important;
    height: 320px !important;
  }


  .rectangle-dump,
  .rectangle-dump1 {
    padding:5px;
  }


}



/* ================= SMALL MOBILE ================= */


@media(max-width:360px){
  .kpi-title {
    font-size:11px;
  }

  .refresh-icon {
    font-size:18px;
  }

  #lineChart1,
  #lineChart2,
  #lineChart3 {
    height:180px !important;
  }

  .barChart1 {
    width: 100% !important;
    min-width: 300px;
    padding: 0px !important;
    height: 320px !important;
  }

}

</style>